import { ArrowRight, MessageCircle, Palette, Ruler, Sparkles } from "lucide-react";
import { waCustomMessage, waLink } from "@/lib/whatsapp";
import { formatIDR } from "@/lib/format";

const STEPS = [
  {
    icon: Palette,
    title: "Pilih warna",
    body: "Sebutkan warna atau nuansa yang kamu mau — pastel, warna hangat, monokrom, atau warna favoritmu.",
  },
  {
    icon: Sparkles,
    title: "Pilih charm",
    body: "Kupu-kupu, bunga, kelinci, ekor ikan, bulan-bintang, atau tanpa charm sama sekali.",
  },
  {
    icon: Ruler,
    title: "Ukuran",
    body: "Kirim lingkar tangan atau kaki kamu dalam cm. Kalau belum tahu, kami bantu cara mengukurnya.",
  },
  {
    icon: MessageCircle,
    title: "Konfirmasi",
    body: "Kami kirim perkiraan tampilan dan harga. Setelah setuju, gelang mulai dirangkai.",
  },
];

export default function CustomOrder() {
  return (
    <div data-testid="custom-order-page">
      <section className="mx-auto max-w-[1440px] px-5 py-16 md:px-10 lg:px-16 lg:py-24">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="label-eyebrow text-sand">Custom Order</p>
            <h1 className="mt-5 font-display text-4xl leading-[1.05] text-ink lg:text-5xl">
              Rancang gelangmu sendiri
            </h1>
            <p className="mt-7 text-base leading-relaxed text-stone">
              Belum menemukan yang pas di koleksi? Kirim warna, charm, dan ukuran yang kamu mau — kami
              rangkai khusus untuk kamu.
            </p>
            <a
              href={waLink(waCustomMessage())}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-10 inline-flex items-center gap-3 bg-ink px-9 py-4 text-[11px] uppercase tracking-[0.22em] text-paper transition-colors duration-300 hover:bg-espresso"
              data-testid="custom-whatsapp-cta"
            >
              Mulai Custom via WhatsApp <ArrowRight size={15} />
            </a>
            <p className="mt-4 text-[11px] text-stone">
              Chat akan terbuka berisi formulir singkat yang tinggal kamu isi.
            </p>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <div className="grid gap-10 sm:grid-cols-2">
              {STEPS.map(({ icon: Icon, title, body }, i) => (
                <div key={title} className="fade-up" style={{ animationDelay: `${i * 90}ms` }}>
                  <Icon size={20} strokeWidth={1.3} className="text-sand" />
                  <h2 className="mt-4 font-display text-xl text-ink">
                    {i + 1}. {title}
                  </h2>
                  <p className="mt-2 text-sm leading-relaxed text-stone">{body}</p>
                </div>
              ))}
            </div>

            <div className="mt-14 border-t border-line pt-10">
              <p className="label-eyebrow text-sand">Yang perlu diketahui</p>
              <ul className="mt-6 space-y-3 text-sm leading-relaxed text-stone">
                <li>· Harga custom mulai dari {formatIDR(30000)} untuk gelang tangan dan {formatIDR(35000)} untuk gelang kaki.</li>
                <li>· Charm khusus atau material tertentu bisa menambah harga — kami info dulu sebelum dikerjakan.</li>
                <li>· Pengerjaan 2–4 hari, tergantung ketersediaan beads.</li>
                <li>· Bisa untuk hadiah, seserahan, atau gelang pasangan/keluarga.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
